import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Badge,
  Button,
  Menu,
  TextInput,
  MultiSelect,
  ActionIcon,
  Group,
  Card,
  Collapse,
  Tooltip,
  Flex,
  Modal,
} from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import {
  IconX,
  IconCheck,
  IconTrash,
  IconFilter,
  IconMoodEmptyFilled,
  IconHourglassEmpty,
  IconTrashX,
  IconArrowNarrowLeft,
  IconFilterPlus,
  IconFilterCancel,
  IconShoppingCartPlus,
} from "@tabler/icons-react";
import { DatePicker } from "@mantine/dates";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import config from "config";
import { toast } from "react-toastify";
import PendingFilters from "./PendingFIlters";

const FiltreMantineTable = forwardRef((props, ref) => {
  const {
    columns,
    data,
    table,
    api,
    setData,
    pagination,
    setQuery,
    setActif,
    actif,
    nomControlleur,
    getFilters,
    isModalOpen,
    setModalOpen,
    openModal,
    closeModal,
    load_filters,
    setSelectedOptionFilters,
    setSelectedOptionId,
    // Nouvelle prop pour les filtres en attente
    pendingFilters,
    setPendingFilters,
    // Filter
    filters,
    setFilters,
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const api_2 = config.backOffice.apiName;
  console.log("actif", actif);
  const [filterName, setFilterName] = useState("");
  // const [filters, setFilters] = useState(actif)
  // const [pendingFilters, setPendingFilters] = useState([])
  const [menuState, setMenuState] = useState({
    selectedColumn: "",
    selectedCondition: "",
    value: "",
  });
  const [clickOutside, setClickOutside] = useState(true);
  const token = localStorage.getItem("auth_token_" + api_2);
  console.log("filter", filters);
  console.log("menu", menuState);
  useEffect(() => {
    if (!menuState.selectedColumn) return;
    const columnType = columns.find(
      (col) => col.accessorKey === menuState.selectedColumn
    )?.type;
    const existingFilter = filters[menuState.selectedColumn];

    if (existingFilter?.type === "select") {
      let formattedValue;

      if (existingFilter.type === "select") {
        formattedValue = Array.isArray(existingFilter.value)
          ? existingFilter.value
          : [existingFilter.value];
      } else {
        formattedValue = existingFilter.value;
      }

      setMenuState((prev) => ({
        ...prev,
        selectedCondition: existingFilter.operator || "",
        value: formattedValue,
      }));
    }
  }, [menuState.selectedColumn, columns]);

  const dispatch = useDispatch();
  // Appliquer les filtres sur les données chaque fois que les filtres changent
  useEffect(() => {
    applyFilters();
  }, [filters]);
  console.log("filters", filters);
  // Exposer des méthodes via la ref
  useImperativeHandle(ref, () => ({
    createFilter: handleCreateFilter,
    filters: filters,
  }));
  // Creation du filtre
  const handleCreateFilter = async () => {
    if (!filters || Object.keys(filters).length === 0) {
      toast.error("Aucun filtre à enregistrer");
      return;
    }
    if (!filterName) {
      toast.error("Veuillez entrer un nom pour le filtre !");
      return;
    }

    // Fonction pour traiter un filtre individuel
    const processFilter = (key, filterObj, acc) => {
      const { value, operator, type } = filterObj;

      if (type === "text") {
        if (operator === "commence par") acc[key + "_like"] = `^${value}`;
        if (operator === "contient") acc[key + "_like"] = `${value}`;
        if (operator === "fini par") acc[key + "_like"] = `${value}$`;
        if (operator === "égale à") acc[key + "_equals"] = `${value}`;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      if (type === "number") {
        if (operator === "supérieur à") acc[key + "_gt"] = `${value}`;
        if (operator === "supérieur ou égal à") acc[key + "_gte"] = `${value}`;
        if (operator === "inférieur à") acc[key + "_lt"] = `${value}`;
        if (operator === "inférieur ou égal à") acc[key + "_lte"] = `${value}`;
        if (operator === "égale à") acc[key + "_equals"] = `${value}`;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      if (type === "select") {
        const selectedValues = Array.isArray(value) ? value : [value];
        acc[key] = selectedValues.join(",");
      }

      if (type === "date") {
        const formattedValue = formatDateFR(value);

        if (operator === "égale à") acc[key + "_equals"] = formattedValue;
        if (operator === "avant") acc[key + "_lt"] = formattedValue;
        if (operator === "après") acc[key + "_gt"] = formattedValue;
        if (operator === "est vide") acc[key + "_is_null"] = true;
        if (operator === "après ou égal à") acc[key + "_gte"] = formattedValue;
        if (operator === "avant ou égal à") acc[key + "_lte"] = formattedValue;
      }

      return acc;
    };

    const filterParams = Object.keys(actif).reduce((acc, key) => {
      const filterValue = actif[key];

      // Gérer le cas où filterValue est un tableau (filtres accumulés)
      if (Array.isArray(filterValue)) {
        // Utiliser une Map pour éviter les doublons de conditions
        const conditionMap = new Map();

        filterValue.forEach((filter) => {
          const { operator, type } = filter;
          let conditionKey;

          // Générer une clé unique pour chaque type de condition
          if (type === "text") {
            if (operator === "commence par") conditionKey = `${key}_like_start`;
            if (operator === "contient") conditionKey = `${key}_like`;
            if (operator === "fini par") conditionKey = `${key}_like_end`;
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
          }

          if (type === "number") {
            if (operator === "supérieur à") conditionKey = `${key}_gt`;
            if (operator === "supérieur ou égal à") conditionKey = `${key}_gte`;
            if (operator === "inférieur à") conditionKey = `${key}_lt`;
            if (operator === "inférieur ou égal à") conditionKey = `${key}_lte`;
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
          }

          if (type === "select") {
            conditionKey = `${key}`;
          }

          if (type === "date") {
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "avant") conditionKey = `${key}_lt`;
            if (operator === "après") conditionKey = `${key}_gt`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
            if (operator === "après ou égal à") conditionKey = `${key}_gte`;
            if (operator === "avant ou égal à") conditionKey = `${key}_lte`;
          }

          // Stocker le dernier filtre pour cette condition (remplace si existe)
          if (conditionKey) {
            conditionMap.set(conditionKey, filter);
          }
        });

        // Traiter chaque filtre unique
        conditionMap.forEach((filter) => {
          processFilter(key, filter, acc);
        });
      } else {
        // Gérer le cas où filterValue est un objet simple (rétrocompatibilité)
        processFilter(key, filterValue, acc);
      }

      return acc;
    }, {});

    const filterPayload = {
      name: filterName,
      controlleur: nomControlleur,
      filter_params: filterParams,
    };

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api_2}/preferences_filters/create_filter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(filterPayload),
        }
      );

      if (response.ok) {
        const result = await response.json();
        dispatch(setSelectedOptionId(result.id));
        toast.success("Filtre enregistré avec succès !");
        setFilterName("");
        getFilters();
        closeModal();
      } else {
        toast.error("Échec de l'enregistrement du filtre.");
      }
    } catch (error) {
      toast.error("Erreur réseau. Veuillez réessayer.");
    }
  };

  // Load the filters
  // const transformFilterParams = () => {
  //   const result = {};

  //   Object.keys(load_filters)?.forEach((key) => {
  //     const value = load_filters[key];
  //     let baseKey = key;
  //     let operator = null;
  //     let type = "text";

  //     if (key.endsWith("_like")) {
  //       baseKey = key.replace("_like", "");
  //       type = "text";
  //       if (value.startsWith("^")) {
  //         operator = "begin with";
  //       } else if (value.endsWith("$")) {
  //         operator = "ended with";
  //       } else {
  //         operator = "contains";
  //       }
  //     } else if (key.endsWith("_gt")) {
  //       baseKey = key.replace("_gt", "");
  //       type = key.includes("date") ? "date" : "number";
  //       operator = type === "date" ? "after" : "greater than";
  //     } else if (key.endsWith("_lt")) {
  //       baseKey = key.replace("_lt", "");
  //       type = key.includes("date") ? "date" : "number";
  //       operator = type === "date" ? "before" : "less than";
  //     } else if (key.endsWith("_equals")) {
  //       baseKey = key.replace("_equals", "");
  //       type = key.includes("date")
  //         ? "date"
  //         : key.includes("number")
  //         ? "number"
  //         : "text";
  //       operator = "equal to";
  //     } else if (key.endsWith("_is_null")) {
  //       baseKey = key.replace("_is_null", "");
  //       type = key.includes("date")
  //         ? "date"
  //         : key.includes("number")
  //         ? "number"
  //         : "text";
  //       operator = "is empty";
  //     } else {
  //       type = "select";
  //       operator = "select";
  //     }

  //     const parsedValue = type === "select" ? value.split(",") : value;

  //     result[baseKey] = {
  //       type,
  //       operator,
  //       value:
  //         typeof value === "boolean"
  //           ? ""
  //           : type === "text"
  //           ? value?.replace(/[\^\$]/g, "")
  //           : parsedValue,
  //     };
  //   });

  //   return result;
  // };
  const transformFilterParams = () => {
    const tempResult = {}; // Stockage temporaire avec clés composites
    const result = {}; // Résultat final groupé par baseKey

    Object.keys(load_filters)?.forEach((key) => {
      const value = load_filters[key];
      let baseKey = key;
      let operator = null;
      let type = "text";

      if (key.endsWith("_like")) {
        baseKey = key.replace("_like", "");
        type = "text";
        if (value.startsWith("^")) {
          operator = "commence par";
        } else if (value.endsWith("$")) {
          operator = "fini par";
        } else {
          operator = "contient";
        }
      } else if (key.endsWith("_gt")) {
        baseKey = key.replace("_gt", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "après" : "supérieur à";
      } else if (key.endsWith("_gte")) {
        baseKey = key.replace("_gte", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "après ou égal à" : "supérieur ou égal à";
      } else if (key.endsWith("_lt")) {
        baseKey = key.replace("_lt", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "avant" : "inférieur à";
      } else if (key.endsWith("_lte")) {
        baseKey = key.replace("_lte", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "avant ou égal à" : "inférieur ou égal à";
      } else if (key.endsWith("_equals")) {
        baseKey = key.replace("_equals", "");
        type = key.includes("date")
          ? "date"
          : key.includes("number")
          ? "number"
          : "text";
        operator = "égale à";
      } else if (key.endsWith("_is_null")) {
        baseKey = key.replace("_is_null", "");
        type = key.includes("date")
          ? "date"
          : key.includes("number")
          ? "number"
          : "text";
        operator = "est vide";
      } else {
        type = "select";
        operator = "select";
      }

      const parsedValue = type === "select" ? value.split(",") : value;

      // Clé composite pour éviter doublons de conditions
      const conditionKey = `${baseKey}_${operator}`;

      // Stocker avec remplacement automatique si même condition
      tempResult[conditionKey] = {
        baseKey,
        type,
        operator,
        value:
          typeof value === "boolean"
            ? ""
            : type === "text"
            ? value?.replace(/[\^\$]/g, "")
            : parsedValue,
      };
    });

    // Regrouper par baseKey
    Object.values(tempResult).forEach(({ baseKey, type, operator, value }) => {
      const filterObj = { type, operator, value };

      if (result[baseKey]) {
        // Si la baseKey existe déjà
        if (Array.isArray(result[baseKey])) {
          // Si c'est déjà un tableau, vérifier si l'opérateur existe
          const existingIndex = result[baseKey].findIndex(
            (filter) => filter.operator === operator
          );

          if (existingIndex !== -1) {
            // Remplacer l'ancien filtre
            result[baseKey][existingIndex] = filterObj;
          } else {
            // Ajouter le nouveau filtre
            result[baseKey].push(filterObj);
          }
        } else {
          // Si c'est un objet simple, vérifier l'opérateur
          if (result[baseKey].operator === operator) {
            // Remplacer directement
            result[baseKey] = filterObj;
          } else {
            // Convertir en tableau avec l'ancien et le nouveau
            result[baseKey] = [result[baseKey], filterObj];
          }
        }
      } else {
        // Nouvelle baseKey
        result[baseKey] = filterObj;
      }
    });

    return result;
  };

  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false); // Marque le premier rendu comme terminé
      return; // Sortie anticipée pour éviter l'exécution
    }

    setFilters(transformFilterParams());
  }, [load_filters]);

  // Appliquer les filtres
  const applyFilters = async () => {
    const buildQueryPart = (key, filterObj) => {
      const { value, type, operator } = filterObj;

      if (!value && operator !== "est vide") return null;

      if (type === "text") {
        if (operator === "commence par")
          return { query: `${key}_like=^${value}`, operator: "like" };
        if (operator === "contient")
          return { query: `${key}_like=${value}`, operator: "like" };
        if (operator === "fini par")
          return { query: `${key}_like=${value}$`, operator: "like" };
        if (operator === "égale à")
          return { query: `${key}_equals=${value}`, operator: "equals" };
        if (operator === "est vide")
          return { query: `${key}_is_null=true`, operator: "is_null" };
      }

      if (type === "number") {
        if (operator === "supérieur à")
          return { query: `${key}_gt=${value}`, operator: "gt" };
        if (operator === "supérieur ou égal à")
          return { query: `${key}_gte=${value}`, operator: "gte" };
        if (operator === "inférieur à")
          return { query: `${key}_lt=${value}`, operator: "lt" };
        if (operator === "inférieur ou égal à")
          return { query: `${key}_lte=${value}`, operator: "lte" };
        if (operator === "égale à")
          return { query: `${key}_equals=${value}`, operator: "equals" };
        if (operator === "est vide")
          return { query: `${key}_is_null=true`, operator: "is_null" };
      }

      if (type === "select") {
        const selectedValues = Array.isArray(value) ? value : [value];
        return { query: `${key}=${selectedValues.join(",")}`, operator: "in" };
      }

      if (type === "date") {
        if (operator === "égale à")
          return { query: `${key}_equals=${value}`, operator: "equals" };
        if (operator === "avant")
          return { query: `${key}_lt=${value}`, operator: "lt" };
        if (operator === "après")
          return { query: `${key}_gt=${value}`, operator: "gt" };
        if (operator === "est vide")
          return { query: `${key}_is_null=true`, operator: "is_null" };
        if (operator === "avant ou égal à")
          return { query: `${key}_lte=${value}`, operator: "lte" };
        if (operator === "après ou égal à")
          return { query: `${key}_gte=${value}`, operator: "gte" };
      }

      return null;
    };

    const conditionMap = new Map(); // Clé: "column_operator", Valeur: query string

    Object.keys(filters).forEach((key) => {
      const filterValue = filters[key];

      if (Array.isArray(filterValue)) {
        filterValue.forEach((filter) => {
          const result = buildQueryPart(key, filter);
          if (result) {
            const conditionKey = `${key}_${result.operator}`;
            // Si la condition existe déjà, elle sera remplacée (dernier filtre gagne)
            conditionMap.set(conditionKey, result.query);
          }
        });
      } else {
        const result = buildQueryPart(key, filterValue);
        if (result) {
          const conditionKey = `${key}_${result.operator}`;
          conditionMap.set(conditionKey, result.query);
        }
      }
    });

    // Convertir la Map en array de queries
    const query = Array.from(conditionMap.values()).join("&");

    dispatch(setActif(filters));
    dispatch(setQuery(query));
  };

  const handleAddPendingFilter = () => {
    const { selectedColumn, selectedCondition, value } = menuState;

    const newFilter = {
      column: selectedColumn,
      condition: selectedCondition,
      value,
    };

    setPendingFilters((prev) => {
      // Chercher l'index du filtre existant avec la même colonne/condition
      const existingIndex = prev.findIndex(
        (filter) =>
          filter.column === newFilter.column &&
          filter.condition === newFilter.condition
      );

      if (existingIndex !== -1) {
        // Remplacer le filtre existant
        const newArray = [...prev];
        newArray[existingIndex] = newFilter;
        return newArray;
      } else {
        // Ajouter le nouveau filtre
        return [...prev, newFilter];
      }
    });

    setMenuState({ selectedColumn: "", selectedCondition: "", value: "" });
    setClickOutside(true);
    setMenuOpen(false);
  };

  const handleApplyPendingFilters = () => {
    const newFilters = { ...filters };
    const operatorMap = {
      "Begin with": "begin with",
      Contains: "contains",
      "Ended with": "ended with",
      "Equal to": "equal to",
      "Not equal to": "Not equal to",
      Before: "before",
      After: "after",
      "Greater than": "greater than",
      "Less than": "less than",
      select: "select",
      "Is empty": "is empty",
      "Greater than or equal to": "greater than or equal to",
      "Less than or equal to": "less than or equal to",
      "Before or equal to": "before or equal to",
      "After or equal to": "after or equal to",
    };

    pendingFilters.forEach(({ column, condition, value }) => {
      const newFilter = {
        type: columns.find((col) => col.accessorKey === column).type,
        operator: operatorMap[condition],
        value,
      };

      if (newFilters[column]) {
        if (Array.isArray(newFilters[column])) {
          // Chercher si une condition identique existe déjà
          const existingIndex = newFilters[column].findIndex(
            (filter) => filter.operator === newFilter.operator
          );

          if (existingIndex !== -1) {
            // Remplacer l'ancien filtre par le nouveau
            newFilters[column][existingIndex] = newFilter;
          } else {
            // Ajouter le nouveau filtre (condition différente)
            newFilters[column].push(newFilter);
          }
        } else {
          // Si c'est un objet simple, vérifier la condition
          if (newFilters[column].operator === newFilter.operator) {
            // Remplacer directement (même condition)
            newFilters[column] = newFilter;
          } else {
            // Transformer en tableau avec l'ancien et le nouveau filtre
            newFilters[column] = [newFilters[column], newFilter];
          }
        }
      } else {
        // Nouvelle colonne, créer un nouveau filtre
        newFilters[column] = newFilter;
      }
    });

    setFilters(newFilters);
    setPendingFilters([]);
  };

  const handleRemoveFilter = (column, index = null) => {
    setFilters((prev) => {
      const newFilters = { ...prev };

      if (index !== null && Array.isArray(newFilters[column])) {
        // Supprimer un filtre spécifique dans un tableau
        const updatedArray = newFilters[column].filter((_, i) => i !== index);

        if (updatedArray.length === 0) {
          // Si plus de filtres pour cette colonne, supprimer la clé
          delete newFilters[column];
        } else if (updatedArray.length === 1) {
          // Si un seul filtre reste, le convertir en objet simple
          newFilters[column] = updatedArray[0];
        } else {
          // Sinon, garder le tableau
          newFilters[column] = updatedArray;
        }
      } else {
        // Supprimer toute la colonne (comportement original)
        delete newFilters[column];
      }

      return newFilters;
    });
  };
  const handleRemovePendingFilter = (index) => {
    setPendingFilters((prev) => prev.filter((_, i) => i !== index));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAddPendingFilter();
    }
  };
  return (
    <>
      <div>
        {/* /* Modal pour le nom du filtre à enregistrer */}
        <Modal
          opened={isModalOpen}
          onClose={closeModal}
          title="Save new filter"
          centered
        >
          {pendingFilters?.length > 0 && (
            <Badge color="orange" variant="filled" mb="md">
              Les filtres en attente ne seront pas sauvegardés
            </Badge>
          )}
          <TextInput
            label="Nom du filtre"
            placeholder="Entrez le nom du filtre"
            value={filterName}
            onChange={(event) => setFilterName(event.target.value)}
          />
          <Group position="right" mt="md">
            <Button variant="default" onClick={closeModal}>
              Annuler
            </Button>
            <Button onClick={handleCreateFilter}>Enregistrer</Button>
          </Group>
        </Modal>
        <Flex direction="row" gap="7" align="center">
          {/* Boutons d'action à gauche */}
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <Menu
              shadow="md"
              width={400}
              closeOnItemClick={false}
              closeOnClickOutside={clickOutside}
              opened={menuOpen}
              onClose={() => setMenuOpen(false)}
            >
              <Menu.Target>
                <Tooltip
                  label="Ajouter un filtre"
                  withArrow
                  position="top"
                  withinPortal
                >
                  <IconFilter
                    size={24}
                    className="m-1"
                    onClick={() => setMenuOpen((prev) => !prev)}
                    color="blue"
                    style={{
                      cursor: "pointer",
                      width: "24px",
                      height: "24px",
                      minWidth: "24px",
                      minHeight: "24px",
                    }}
                  />
                </Tooltip>
              </Menu.Target>

              <Menu.Dropdown>
                {!menuState.selectedColumn &&
                  columns.map((header) => (
                    <Menu.Item
                      key={header.accessorKey}
                      onClick={() => {
                        setMenuState((prev) => ({
                          ...prev,
                          selectedColumn: header.accessorKey,
                        }));
                      }}
                    >
                      {header.header}
                    </Menu.Item>
                  ))}

                {menuState.selectedColumn &&
                  (!menuState.selectedCondition ||
                    menuState.selectedCondition == "select") && (
                    <>
                      <Menu.Item>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            onClick={() => {
                              setMenuState((prev) => ({
                                ...prev,
                                selectedColumn: "",
                                selectedCondition: "",
                                value: "",
                              })),
                                setClickOutside(true);
                            }}
                          >
                            <IconArrowNarrowLeft /> Retour
                          </Button>
                          {columns.find(
                            (header) =>
                              header.accessorKey === menuState.selectedColumn
                          )?.type === "select" ? (
                            <Button
                              onClick={handleAddPendingFilter}
                              color="green"
                            >
                              Ajouter aux filtres en attente
                            </Button>
                          ) : null}
                        </div>
                      </Menu.Item>
                      {columns.find(
                        (header) =>
                          header.accessorKey === menuState.selectedColumn
                      ).type === "text" &&
                        [
                          "Commence par",
                          "Contient",
                          "Fini par",
                          "Égale",
                          "Est vide",
                        ].map((condition) => (
                          <Menu.Item
                            key={condition}
                            onClick={() =>
                              setMenuState((prev) => ({
                                ...prev,
                                selectedCondition: condition,
                              }))
                            }
                            style={{
                              backgroundColor:
                                condition == "Est vide" ? "#FFDD57" : "",
                            }}
                          >
                            {condition}
                          </Menu.Item>
                        ))}
                      {columns.find(
                        (header) =>
                          header.accessorKey === menuState.selectedColumn
                      ).type === "number" &&
                        [
                          "Supérieur à",
                          "Supérieur ou égal à",
                          "Inférieur à",
                          "Inférieur ou égal à",
                          "Égale",
                          "Est vide",
                        ].map((condition) => (
                          <Menu.Item
                            key={condition}
                            onClick={() =>
                              setMenuState((prev) => ({
                                ...prev,
                                selectedCondition: condition,
                              }))
                            }
                            style={{
                              backgroundColor:
                                condition == "Is empty" ? "#FFDD57" : "",
                            }}
                          >
                            {condition}
                          </Menu.Item>
                        ))}
                      {columns.find(
                        (header) =>
                          header.accessorKey === menuState.selectedColumn
                      ).type === "date" &&
                        [
                          "Avant",
                          "Avant ou égal à",
                          "Après",
                          "Après ou égal à",
                          "Égale",
                          "Est vide",
                        ].map((condition) => (
                          <Menu.Item
                            key={condition}
                            onClick={() =>
                              setMenuState((prev) => ({
                                ...prev,
                                selectedCondition: condition,
                              }))
                            }
                            style={{
                              backgroundColor:
                                condition == "Est vide" ? "#FFDD57" : "",
                            }}
                          >
                            {condition}
                          </Menu.Item>
                        ))}
                    </>
                  )}

                {columns.find(
                  (header) => header.accessorKey === menuState.selectedColumn
                )?.type === "select" && (
                  <>
                    <Menu.Item closeOnClick={false}>
                      <MultiSelect
                        hidePickedOptions
                        onKeyDown={handleKeyDown}
                        withinPortal
                        searchable
                        data={
                          columns
                            .find(
                              (header) =>
                                header.accessorKey === menuState.selectedColumn
                            )
                            ?.options.map((option) => ({
                              value: String(option.value),
                              label: String(option.label),
                            })) || []
                        }
                        value={menuState.value || []}
                        onChange={(value) =>
                          setMenuState((prev) => ({
                            ...prev,
                            selectedCondition: "select",
                            value,
                          }))
                        }
                        placeholder={`Select for ${
                          columns.find(
                            (header) =>
                              header.accessorKey === menuState.selectedColumn
                          )?.header || ""
                        }`}
                        onClick={() => setClickOutside(!clickOutside)}
                        renderOption={(option) => (
                          <div
                            style={{
                              backgroundColor:
                                option.option.label == "[ is empty ]"
                                  ? "#FFDD57"
                                  : "transparent",
                              color:
                                option.option.label == "[ is empty ]"
                                  ? "black"
                                  : "inherit",
                              padding: "8px 12px",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                          >
                            {option.option.label}
                          </div>
                        )}
                      />
                    </Menu.Item>
                  </>
                )}

                {menuState.selectedColumn &&
                  menuState.selectedCondition &&
                  menuState.selectedCondition !== "select" && (
                    <>
                      <Menu.Item>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            onClick={() => {
                              setMenuState((prev) => ({
                                ...prev,
                                selectedColumn: "",
                                selectedCondition: "",
                              })),
                                setClickOutside(true);
                            }}
                          >
                            <IconArrowNarrowLeft /> Retour
                          </Button>
                          {columns.find(
                            (header) =>
                              header.accessorKey === menuState.selectedColumn
                          )?.type != "select" ? (
                            <Button
                              onClick={handleAddPendingFilter}
                              color="green"
                            >
                              Ajouter aux filtres en attente
                            </Button>
                          ) : null}
                        </div>
                      </Menu.Item>
                      {menuState.selectedCondition !== "Est vide" && (
                        <Menu.Item>
                          {columns.find(
                            (header) =>
                              header.accessorKey === menuState.selectedColumn
                          ).type === "date" ? (
                            <DatePicker
                              placeholder="Select date"
                              value={
                                menuState.value
                                  ? new Date(
                                      menuState.value
                                        .split("/")
                                        .reverse()
                                        .join("-")
                                    )
                                  : null
                              }
                              onChange={(date) =>
                                setMenuState((prev) => ({
                                  ...prev,
                                  value: date
                                    ? `${date
                                        .getDate()
                                        .toString()
                                        .padStart(2, "0")}/${(
                                        date.getMonth() + 1
                                      )
                                        .toString()
                                        .padStart(
                                          2,
                                          "0"
                                        )}/${date.getFullYear()}`
                                    : "",
                                }))
                              }
                            />
                          ) : (
                            <TextInput
                              placeholder={`${
                                columns.find(
                                  (header) =>
                                    header.accessorKey ===
                                    menuState.selectedColumn
                                ).header
                              } ${menuState.selectedCondition.toLowerCase()}`}
                              value={menuState.value}
                              onChange={(e) =>
                                setMenuState((prev) => ({
                                  ...prev,
                                  value: e.target.value,
                                }))
                              }
                              onKeyDown={handleKeyDown}
                            />
                          )}
                        </Menu.Item>
                      )}
                    </>
                  )}
              </Menu.Dropdown>
            </Menu>

            {Object.entries(filters).length > 0 && (
              <Tooltip
                label="Vider le filtre"
                withArrow
                position="top"
                withinPortal
              >
                <IconFilterCancel
                  className="m-1"
                  style={{
                    cursor: "pointer",
                    width: "24px",
                    height: "24px",
                    minWidth: "24px",
                    minHeight: "24px",
                  }}
                  onClick={() => {
                    setFilters({});
                    dispatch(setSelectedOptionFilters(null));
                  }}
                  color="red"
                />
              </Tooltip>
            )}
          </div>

          {/* Filtres actifs à droite */}
          {/* <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "2px",
              flex: 1,
              maxWidth: "50vh",
            }}
            className={
              Object.keys(filters).length > 0 ? "input-group-text p-1" : "p-1"
            }
          >
            {Object.keys(columns).length > 0 &&
              (() => {
                const uniqueConditions = new Map()

                // Collecter tous les filtres et garder seulement les uniques par condition
                Object.keys(filters).forEach(column => {
                  const filterValue = filters[column]
                  const columnHeader = columns.find(
                    header => header.accessorKey === column
                  )
                  if (Array.isArray(filterValue)) {
                    filterValue.forEach((filter, index) => {
                      const conditionKey = `${column}_${filter.operator}`
                      uniqueConditions.set(conditionKey, {
                        column,
                        filter,
                        index,
                        columnHeader,
                        isArray: true,
                      })
                    })
                  } else {
                    const conditionKey = `${column}_${filterValue.operator}`
                    uniqueConditions.set(conditionKey, {
                      column,
                      filter: filterValue,
                      index: null,
                      columnHeader,
                      isArray: false,
                    })
                  }
                })

                // Convertir la Map en array de badges
                return Array.from(uniqueConditions.values()).map(
                  ({ column, filter, index, columnHeader, isArray }) => (
                    <Badge
                      key={`${column}-${filter.operator}`}
                      color="blue"
                      style={{ maxWidth: "500px" }}
                      rightSection={
                        <ActionIcon
                          size="xs"
                          color="blue"
                          onClick={() =>
                            handleRemoveFilter(
                              column,
                              isArray ? index : undefined
                            )
                          }
                        >
                          <IconX size={10} />
                        </ActionIcon>
                      }
                    >
                      <Tooltip
                        label={`${columnHeader?.header} ${filter.operator}${
                          filter.operator === "is empty" ? "" : ":"
                        } ${
                          filter.type === "select"
                            ? (() => {
                                const statut = String(filter.value)
                                const statutOptions =
                                  columnHeader?.options || []
                                const statutLabels = statut
                                  .split(",")
                                  .map(val => {
                                    const match = statutOptions.find(
                                      option => option.value == parseInt(val)
                                    )
                                    return match ? match.label : null
                                  })
                                  .filter(label => label !== null)
                                return statutLabels.join(", ")
                              })()
                            : filter.value
                        }`}
                        withArrow
                        position="bottom"
                        withinPortal
                        styles={theme => ({
                          tooltip: {
                            backgroundColor: "black",
                            color: "white",
                            maxWidth: "300px",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                          },
                        })}
                      >
                        <span
                          style={{
                            paddingTop: "6px",
                            fontWeight: "normal",
                            textTransform: "none",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "inline-block",
                            maxWidth: "100%",
                          }}
                        >
                          {`${columnHeader?.header} ${filter.operator}${
                            filter.operator === "is empty" ? "" : ":"
                          } ${
                            filter.type === "select"
                              ? (() => {
                                  const statut = String(filter.value)
                                  const statutOptions =
                                    columnHeader?.options || []
                                  const statutLabels = statut
                                    .split(",")
                                    .map(val => {
                                      const match = statutOptions.find(
                                        option => option.value == parseInt(val)
                                      )
                                      return match ? match.label : null
                                    })
                                    .filter(label => label !== null)
                                  return statutLabels.join(", ")
                                })()
                              : filter.value
                          }`}
                        </span>
                      </Tooltip>
                    </Badge>
                  )
                )
              })()}
          </div> */}
        </Flex>
      </div>
    </>
  );
});

export default FiltreMantineTable;
